import { render } from "./MensajesView.vue?vue&type=template&id=1a5de96f&ts=true"
import script from "./MensajesView.vue?vue&type=script&lang=ts"
export * from "./MensajesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__